import { MdUpload } from "react-icons/md";
import XButton from "../common/XButton";
import { spinnerClasses } from "../common/loaderClasses";

const disabledErrorClasses = 'text-danger! border-danger! opacity-90';

export const FileUploadBtn = ({
    text,
    isBorder,
    isDisabled,
    isLoading,
    onClick,
    variant,
}) => (
    <XButton
        variant={variant ?? (isBorder ? "outlinePrimary" : "primary")}
        className={isDisabled ? disabledErrorClasses : ""}
        disabled={isDisabled || isLoading}
        onClick={onClick}
    >
        {isLoading ? (
            <span className={spinnerClasses} role="status" aria-label="Loading" />
        ) : (
            <>
                <MdUpload size={18} className="translate-y-px" />
                {text}
            </>
        )}
    </XButton>
);
